import React from 'react';
import { Grid } from '@material-ui/core';
import FlexView from 'react-flexview/lib';
import { ReactComponent as CheckVerifiedIcon } from '../../assets/check_verified.svg';
import { ReactComponent as FileCheckIcon } from '../../assets/file_check.svg';


const PolicyCertificates = ({shrink, isMobile , openCOIUrl, openPolicyUrl }) => {
    return (
        <>
            <Grid container spacing={2} className="margin-bottom-basic">
                <Grid item xs={ shrink && !isMobile ? 9 : 6}>
                    <button className="button-primary full-width" onClick={openCOIUrl}>
                        <FlexView vAlignContent="center" hAlignContent="center">
                            <CheckVerifiedIcon className="x-medium-icon" />
                            <FlexView className={`${isMobile && 'text-medium'} bold`} marginLeft={4}>
                            {isMobile ? 'COI' : 'Certificate of Insurance'}
                            </FlexView>
                        </FlexView>
                    </button>
                </Grid>
                <Grid item xs={shrink && !isMobile ? 3 : 6}>
                    <button className="button-primary full-width">
                        <FlexView vAlignContent="center" hAlignContent="center" onClick={openPolicyUrl}>
                            <FileCheckIcon className="x-medium-icon" />
                            <FlexView className={`${isMobile && 'text-medium'} bold`} marginLeft={4}>
                            Policy
                            </FlexView>
                        </FlexView>
                    </button>
                </Grid>
            </Grid>
        </>
    );
};

export default PolicyCertificates; 